import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { Helmet } from 'react-helmet-async';

import {
  PageContainer,
  PageHero,
  Section,
  Protected,
} from '../theme/primitives';

const key = 'dqweqwe123y97qhduiasd$@^!*#&bjasdja&^&@!#';

const termsItems = [
  'Please enter only relevant details at the time of registration.',
  'After registration as Material & Machinery suppliers, Testing laboratories, Consultants or Contractors can add their product / service by clicking "My Products / Services" in their Dashboard. They then need to choose a Subscription plan in "My Subscription" which activates the "Contact Now" button on their listing.',
  'Every time a material or machinery supplier, testing laboratory, consultant, or contractor adds/updates product/service details, they are validated and approved/rejected by the backend team. Ensure only relevant information is provided.',
  'There is no Subscription plan for Engineers and Workforce. Their profile is visible based on the profile-visibility value set at registration; it can be toggled from "Update Details" in "My Account".',
];

const paymentItems = [
  'Once a payment is accepted and a subscription plan is issued, there will be no refunds.',
  'If the amount is debited but the subscription is not issued, the debited amount will be refunded to the source account within 3 to 5 days.',
];

const disclaimerItems = [
  'ESAY gives no guarantee that registration will result in the conclusion of a business offer. The information in the portal is made available to the cross-section of the construction industry.',
  'Inclusion of a contact does not imply a recommendation.',
  'Considerable effort and care goes into incorporating useful information for engineers and people in construction. In case of errors, discrepancies, or omissions, ESAY shall not be liable. Users are requested to rely on professional advice and expertise.',
];

function NumberedList({ items }) {
  return (
    <ul className="mt-2">
      {items.map((text, i) => (
        <li key={i} className="grid grid-cols-[36px_1fr] gap-3 py-3 border-b border-border-subtle last:border-b-0">
          <span className="
            inline-flex h-7 w-7 items-center justify-center rounded-md
            bg-amber/10 border border-amber/24 text-amber
            text-[10.5px] font-bold tracking-[0.06em]
          ">{String(i + 1).padStart(2, '0')}</span>
          <p className="text-[13px] leading-[1.7] text-fg-secondary">{text}</p>
        </li>
      ))}
    </ul>
  );
}

function LegalBlock({ kicker, title, children }) {
  return (
    <article className="
      relative overflow-hidden rounded-2xl
      border border-border-subtle bg-surface-paper
      p-5 sm:p-6 mb-3
    ">
      <span aria-hidden className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-amber/30 to-transparent" />
      <div className="mb-1 inline-flex items-center gap-1.5">
        <span aria-hidden className="inline-flex h-1 w-1 rounded-full bg-amber" />
        <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-amber">{kicker}</span>
      </div>
      <h2 className="text-[17px] sm:text-[19px] font-bold tracking-[-0.018em] text-fg-primary">{title}</h2>
      <div aria-hidden className="mt-2 h-[2px] w-10 rounded-full bg-gradient-to-r from-amber to-amber/0" />
      {children}
    </article>
  );
}

export const Terms = () => {
  const [metadata, setMetadata] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    Axios.post('/new_apis/getsinglemetadata', { type: 'terms' }, { headers: { key } }).then((res) => {
      if (res.data.status) setMetadata(res.data.metadata[0]);
      else setMetadata({ seo_title: 'Terms & Conditions | ESAY' });
    });
  }, []);

  return (
    <Protected onCopy={(e) => e.preventDefault()}>
      {metadata && (
        <Helmet>
          <title>{metadata.seo_title}</title>
          {metadata.seo_desc && <meta name="description" content={metadata.seo_desc} />}
          {metadata.seo_keywords && <meta name="keywords" content={metadata.seo_keywords} />}
        </Helmet>
      )}

      <PageContainer maxWidth="md">
        <PageHero
          compact
          kicker="Legal"
          title="Terms & Conditions"
          subtitle="Please read these terms carefully before using the ESAY platform and services."
        />

        <Section>
          <LegalBlock kicker="01" title="Our Terms & Conditions">
            <NumberedList items={termsItems} />
          </LegalBlock>
          <LegalBlock kicker="02" title="Payment Failure & Refund Policy">
            <NumberedList items={paymentItems} />
          </LegalBlock>
          <LegalBlock kicker="03" title="Disclaimer">
            <NumberedList items={disclaimerItems} />
          </LegalBlock>
        </Section>
      </PageContainer>
    </Protected>
  );
};
